import { render, staticRenderFns } from "./InvoiceInfoView.vue?vue&type=template&id=351b3ad8&scoped=true&mlns=http%3A%2F%2Fwww.w3.org%2F1999%2Fhtml&"
import script from "./InvoiceInfoView.vue?vue&type=script&lang=js&"
export * from "./InvoiceInfoView.vue?vue&type=script&lang=js&"
import style0 from "./InvoiceInfoView.vue?vue&type=style&index=0&id=351b3ad8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "351b3ad8",
  null
  
)

component.options.__file = "InvoiceInfoView.vue"
export default component.exports